import { StopTwoTone } from '@ant-design/icons'
import { Typography } from 'antd'
import { IFIReportTypeItem } from '@cims-online/shared'
import { CIMSCollapsePanelOptions } from 'components/CIMSCollapse/types'

const useNotImported = ({
  id,
  type,
}: Pick<IFIReportTypeItem, 'id' | 'type'>): CIMSCollapsePanelOptions => ({
  header: {
    children: type,
  },
  key: id,
  extra: {
    children: (
      <StopTwoTone
        twoToneColor="#c9c9c9"
        style={{ fontSize: 17 }}
        rotate={90}
      />
    ),
  },
  children: (
    <Typography>
      This module is not yet being imported into the IFI Tracker
    </Typography>
  ),
})

export default useNotImported
